// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-layout .nkl-layout-header {
  width: 100%;
  margin: 0px;
  padding: 0px;
  max-width: 100%;
}
.header-layout .nkl-menu {
  background-color: #394b59;
}
.menu-link {
  color: rgba(138, 155, 168, 0.3);
  padding: 0px;
}
.menu-button {
  border: 0px;
  color: #f5f8fa;
  background-color: #394b59;
}
.menu-button .nkl-btn:hover {
  color: #394b59;
}
.nkl-popover-button {
  color: #fff;
  text-align: center;
  display: inline-block;
  box-sizing: inherit;
  box-shadow: 0 0;
  border-radius: 3px;
  background-color: #394b59;
}
.nkl-popover-button .anticon {
  padding-right: 10px;
  padding-top: 3px;
  float: left;
  align-items: center;
}
.nkl-menu-light {
  background-color: rgba(138, 155, 168, 0.3);
}
.nkl-layout-footer {
  margin: 0px;
}
.nkl-layout .nkl-menu {
  background-color: #394b59;
}
.nkl-menu-overflow {
  background-color: #394b59;
}
.nkl-popover-inner .nkl-popover-inner-content {
  padding: 0px;
}
.nkl-popover-wrapper {
  background-color: #394b59;
}
.nkl-popover-arrow .nkl-popover-arrow-content {
  background-color: #394b59;
  color: #394b59;
}
.nkl-btn-primary:hover {
  background: #30404d;
  color: #f5f8fa;
}
.nkl-popover-button-primary:hover {
  background: #30404d;
  color: #f5f8fa;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
